(() => {
    const config = {
        containerSelector: '.faq__items',
        itemSelector: '.faq__items--item',
        titleSelector: '.faq__items--item--title',
        contentSelector: '.faq__items--item--content',
        itemOpenClass: 'item-open',
        allowMultipleOpen: false
    };

    document.addEventListener('DOMContentLoaded', () => {
        const container = document.querySelector(config.containerSelector);
        if (!container) return;

        const items = container.querySelectorAll(config.itemSelector);

        items.forEach(item => {
            const content = item.querySelector(config.contentSelector);
            if (item.classList.contains(config.itemOpenClass) && content) {
                content.style.maxHeight = `${content.scrollHeight}px`;
            }
        });

        container.addEventListener('click', e => {
            const title = e.target.closest(config.titleSelector);
            if (!title) return;

            const item = title.closest(config.itemSelector);
            const content = item.querySelector(config.contentSelector);
            if (!item || !content) return;

            // Jeśli tylko jeden może być otwarty
            if (!config.allowMultipleOpen) {
                items.forEach(other => {
                    if (other !== item && other.classList.contains(config.itemOpenClass)) {
                        toggleItem(other, false);
                    }
                });
            }

            // Przełącz kliknięty element
            toggleItem(item, !item.classList.contains(config.itemOpenClass));
        });

        /**
         * Funkcja pomocnicza do otwierania/zamykania akordeonu
         */
        function toggleItem(item, open) {
            const content = item.querySelector(config.contentSelector);
            if (!content) return;

            if (open) {
                item.classList.add(config.itemOpenClass);
                // Płynne otwarcie
                content.style.maxHeight = `${content.scrollHeight}px`;
            } else {
                item.classList.remove(config.itemOpenClass);
                // Płynne zamknięcie (z animacją)
                requestAnimationFrame(() => {
                    content.style.maxHeight = null;
                });
            }
        }
    });
})();
